import { isStaff as userIsStaff } from 'utils/userEnvironment';

import { useUserEnvironment } from './useUserEnvironment';

export function useCurrentUserIsStaff() {
  const { user } = useUserEnvironment();
  return user ? userIsStaff(user) : false;
}
